module.exports = __webpack_public_path__ + "img/character03_static.d5c173c7.png";